"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findClosestBlock = void 0;
const blockwise_1 = require("./index");
/**
 * Returns the reference of the closest block of the array.
 *
 * @includeExample ./src/find-closest-block.example.ts
 */
function findClosestBlock(blockList, target) {
    if (blockList.length === 0) {
        throw new Error("Block list should not be empty !");
    }
    let closestPoint = blockList[0];
    let closestDistance = (0, blockwise_1.calculateBlockDistance)(closestPoint, target);
    for (let i = 1; i < blockList.length; i++) {
        const currentBlock = blockList[i];
        const currentDistance = (0, blockwise_1.calculateBlockDistance)(currentBlock, target);
        if (currentDistance < closestDistance) {
            closestPoint = currentBlock;
            closestDistance = currentDistance;
        }
    }
    return closestPoint;
}
exports.findClosestBlock = findClosestBlock;
